import React, { use, useContext, useEffect, useRef, useState } from "react";
import { Context } from "../context/Context";
import "./RoomEquipmentsList.css";
import DimmerShortcutTheme2 from "./shortcuts/theme2/Dimmer";
import FanCoilShortcutTheme2 from "./shortcuts/theme2/FanCoil";
import HumidityShortcutTheme2 from "./shortcuts/theme2/Humidity";
import InputShortcutTheme2 from "./shortcuts/theme2/Input";
import KeyShortcutTheme2 from "./shortcuts/theme2/Key";
import MotorShortcutTheme2 from "./shortcuts/theme2/Motor";
import RemoteShorcutTheme2 from "./shortcuts/theme2/Remote";
import RGBShortcutTheme2 from "./shortcuts/theme2/RGB";
import ScenarioKeyShortcutTheme2 from "./shortcuts/theme2/ScenarioKey";
import TelevisionShortcutTheme2 from "./shortcuts/theme2/Television";
import ThermostatShortcutTheme2 from "./shortcuts/theme2/Thermostat";
import WirelessKeyShorcutTheme2 from "./shortcuts/theme2/WirelessKey";
import InputStatusShortcut from "./shortcuts/theme2/InputStatus";

import TelevisionShortcut from "./shortcuts/Television";
import KeyShortcut from "./shortcuts/Key";
import RemoteShorcut from "./shortcuts/Remote";
import DimmerShortcut from "./shortcuts/Dimmer";
import RGBShortcut from "./shortcuts/RGB";
import FanCoilShortcut from "./shortcuts/FanCoil";
import ScenarioKeyShortcut from "./shortcuts/ScenarioKey";
import HumidityShortcut from "./shortcuts/Humidity";
import MotorShortcut from "./shortcuts/Motor";
import CameraShortcut from "./shortcuts/Camera";
import ThermostatShortcut from "./shortcuts/Thermostat";
import WirelessKeyShorcut from "./shortcuts/WirelessKey";
import InputShortcut from "./shortcuts/Input";
import { useLocation } from "react-router-dom";
import DataLoggerShortcut from "./shortcuts/theme2/DataLogger";

const RoomEquipmentsList = () => {
  const {
    roomEquipments,
    setRoomEquipments,
    openDetailMenu,
    selectedEquipment,
    equipments,
    currentRoom,
    rooms,
  } = useContext(Context);

  const [showScrollbar, setShowScrollbar] = useState(false);
  const containerRef = useRef(null);
  const psRef = useRef(null);

  useEffect(() => {
    // بعد از رندر محتوا، به محل قبلی اسکرول می‌کنیم
    scrollToPreviousPosition();
  }, [roomEquipments]);

  useEffect(() => {
    const roomEquipmentsFiltered = equipments.filter(
      (eq) => eq.room_id == currentRoom,
    );
    setRoomEquipments(roomEquipmentsFiltered);
  }, [equipments, rooms, currentRoom]);

  // useEffect(() => {
  //   // هر بار که openDetailMenu تغییر کند، ابتدا المنت را حذف می‌کنیم
  //   setShowScrollbar(false);

  //   // یک تاخیر کوچک برای حذف و سپس بازسازی المان
  //   const timeout = setTimeout(() => {
  //     setShowScrollbar(true);
  //   }, 10); // تاخیر برای حذف کامل از DOM

  //   return () => clearTimeout(timeout); // پاک‌سازی تایمر
  // }, [openDetailMenu]);

  // useEffect(() => {
  //   if (containerRef.current) {
  //     // حذف ایونت قبلی (در صورت وجود)
  //     if (psRef.current) {
  //       psRef.current.destroy();
  //       psRef.current = null;
  //     }
  //     // ایجاد ایونت جدید
  //     psRef.current = new window.PerfectScrollbar(containerRef.current, {
  //       wheelSpeed: 0.5,
  //       scrollYMarginOffset: 0.5,
  //       suppressScrollY: true,
  //     });
  //   }
  //   return () => {
  //     if (psRef.current) {
  //       psRef.current.destroy();
  //       psRef.current = null;
  //     }
  //   };
  // }, [showScrollbar, containerRef]);

  useEffect(() => {
    const handleWheel = (e) => {
      if (containerRef.current) {
        e.preventDefault();
        containerRef.current.scrollLeft += e.deltaY;
      }
    };

    const el = containerRef.current;
    el?.addEventListener("wheel", handleWheel, { passive: false }); // فیکس شده

    return () => el?.removeEventListener("wheel", handleWheel);
  }, [showScrollbar]);
  const scrollToPreviousPosition = () => {
    const container = containerRef.current;
    if (container) {
      const previousScrollPosition = localStorage.getItem("scrollPosition");
      if (previousScrollPosition) {
        container.scrollLeft = previousScrollPosition;
      }
    }
  };

  const handleScroll = () => {
    const container = containerRef.current;
    if (container) {
      // موقعیت اسکرول رو ذخیره می‌کنیم
      localStorage.setItem("scrollPosition", container.scrollLeft);
    }
  };
  return (
    // <>
    //   {roomEquipments.length > 0 &&
    //     roomEquipments.map((eq) => {
    //       switch (eq.equipment.type) {
    //         case "1":
    //           return (
    //             <KeyShortcut
    //               key={eq.equipment.id}
    //               equipment_id={eq.equipment.id}
    //               equipment_name={eq.equipment.name}
    //             />
    //           );
    //         case "3":
    //           return (
    //             <RemoteShorcut
    //               key={eq.equipment.id}
    //               equipment_id={eq.equipment.id}
    //               equipment_name={eq.equipment.name}
    //             />
    //           );
    //         case "4":
    //           return (
    //             <DimmerShortcut
    //               key={eq.equipment.id}
    //               equipment_id={eq.equipment.id}
    //               equipment_name={eq.equipment.name}
    //             />
    //           );
    //         case "5":
    //           return (
    //             <ThermostatShortcut
    //               key={eq.equipment.id}
    //               equipment_id={eq.equipment.id}
    //               equipment_name={eq.equipment.name}
    //             />
    //           );
    //         case "9":
    //           return (
    //             <RGBShortcut
    //               key={eq.equipment.id}
    //               equipment_id={eq.equipment.id}
    //               equipment_name={eq.equipment.name}
    //             />
    //           );
    //         case "99":
    //           return (
    //             <WirelessKeyShorcut
    //               key={eq.equipment.id}
    //               equipment_id={eq.equipment.id}
    //               equipment_name={eq.equipment.name}
    //             />
    //           );
    //         case "100":
    //           return (
    //             <TelevisionShortcut
    //               key={eq.equipment.id}
    //               equipment_id={eq.equipment.id}
    //               equipment_name={eq.equipment.name}
    //             />
    //           );
    //         case "501":
    //           return (
    //             <FanCoilShortcut
    //               key={eq.equipment.id}
    //               equipment_id={eq.equipment.id}
    //               equipment_name={eq.equipment.name}
    //             />
    //           );
    //         case "401":
    //           return (
    //             <ScenarioKeyShortcut
    //               key={eq.equipment.id}
    //               equipment_id={eq.equipment.id}
    //               equipment_name={eq.equipment.name}
    //             />
    //           );
    //         case "503":
    //           return (
    //             <HumidityShortcut
    //               key={eq.equipment.id}
    //               equipment_id={eq.equipment.id}
    //               equipment_name={eq.equipment.name}
    //             />
    //           );
    //         case "502":
    //           return (
    //             <MotorShortcut
    //               key={eq.equipment.id}
    //               equipment_id={eq.equipment.id}
    //               equipment_name={eq.equipment.name}
    //             />
    //           );
    //         case "9997":
    //           return (
    //             <CameraShortcut
    //               key={eq.equipment.id}
    //               equipment_id={eq.equipment.id}
    //               equipment_name={eq.equipment.name}
    //             />
    //           );
    //         case "9998":
    //           return (
    //             <InputShortcut
    //               key={eq.equipment.id}
    //               equipment_id={eq.equipment.id}
    //               equipment_name={eq.equipment.name}
    //             />
    //           );
    //         default:
    //           return null;
    //       }
    //     })}
    // </>
    <>
      <div className="room-equipments">
        {/* {showScrollbar && ( */}
        <div
          className="equipments d-flex flex-row align-self-center flex-nowrap"
          style={{
            width: openDetailMenu ? "calc(100% - 21rem)" : "calc(100% - 10rem)",
          }}
          onScroll={handleScroll}
          ref={containerRef}
        >
          {roomEquipments.map((eq) => {
            switch (eq.equipment.type) {
              case "1":
                return (
                  <KeyShortcutTheme2
                    key={eq.equipment.id}
                    equipment_id={eq.equipment.id}
                    equipment_name={eq.equipment.name}
                  />
                );
              case "3":
                return (
                  <RemoteShorcutTheme2
                    key={eq.equipment.id}
                    equipment_id={eq.equipment.id}
                    equipment_name={eq.equipment.name}
                  />
                );
              case "4":
                return (
                  <DimmerShortcutTheme2
                    key={eq.equipment.id}
                    equipment_id={eq.equipment.id}
                    equipment_name={eq.equipment.name}
                  />
                );
              case "5":
                return (
                  <ThermostatShortcutTheme2
                    key={eq.equipment.id}
                    equipment_id={eq.equipment.id}
                    equipment_name={eq.equipment.name}
                  />
                );
              case "9":
                return (
                  <RGBShortcutTheme2
                    key={eq.equipment.id}
                    equipment_id={eq.equipment.id}
                    equipment_name={eq.equipment.name}
                  />
                );
              case "99":
                return (
                  <WirelessKeyShorcutTheme2
                    key={eq.equipment.id}
                    equipment_id={eq.equipment.id}
                    equipment_name={eq.equipment.name}
                  />
                );
              case "100":
                return (
                  <TelevisionShortcutTheme2
                    key={eq.equipment.id}
                    equipment_id={eq.equipment.id}
                    equipment_name={eq.equipment.name}
                  />
                );
              case "501":
                return (
                  <FanCoilShortcutTheme2
                    key={eq.equipment.id}
                    equipment_id={eq.equipment.id}
                    equipment_name={eq.equipment.name}
                  />
                );
              case "401":
                return (
                  <ScenarioKeyShortcutTheme2
                    key={eq.equipment.id}
                    equipment_id={eq.equipment.id}
                    equipment_name={eq.equipment.name}
                  />
                );
              case "503":
                return (
                  <HumidityShortcutTheme2
                    key={eq.equipment.id}
                    equipment_id={eq.equipment.id}
                    equipment_name={eq.equipment.name}
                  />
                );
              case "502":
                return (
                  <MotorShortcutTheme2
                    key={eq.equipment.id}
                    equipment_id={eq.equipment.id}
                    equipment_name={eq.equipment.name}
                  />
                );
              // case "9997":
              //   return (
              //     <CameraShortcutTheme2
              //       key={eq.equipment.id}
              //       equipment_id={eq.equipment.id}
              //       equipment_name={eq.equipment.name}
              //     />
              //   );
              case "9998":
                return (
                  <InputShortcutTheme2
                    key={eq.equipment.id}
                    equipment_id={eq.equipment.id}
                    equipment_name={eq.equipment.name}
                  />
                );
              case "9999":
                return (
                  <InputStatusShortcut
                    key={eq.equipment.id}
                    equipment_id={eq.equipment.id}
                    equipment_name={eq.equipment.name}
                  />
                );
              case "600":
                return (
                  <DataLoggerShortcut
                    key={eq.equipment.id}
                    equipment_id={eq.equipment.id}
                    equipment_name={eq.equipment.name}
                  />
                );
              default:
                return null;
            }
          })}
        </div>
        {/* )} */}
      </div>
    </>
  );
};

export default RoomEquipmentsList;
